import { Message,MessageBox,Loading } from 'element-ui';

//===================消息提示（吐司）===================
// /**
//  * 消息提示
//  * @param {提示内容} message
//  * @param {主题} type ：success/warning/info/error
//  * @param {显示时间, 毫秒。设为 0 则不会自动关闭} duration
//  */
// function message_base(type,msg,duration,showClose){
// 	Message ({
//         message:msg,
//         type: type,//主题 success/warning/info/error	info
//         duration: duration,
//         showClose:showClose,//是否显示关闭按钮
//         offset:100,//Message 距离窗口顶部的偏移量
//         center: true,
// 	})
// }

/**
 * 消息提示
 * @param {提示内容} message
 * @param {主题} type ：success/warning/info/error
 * @param {显示时间, 毫秒。设为 0 则不会自动关闭} duration
 */
function message_base2(type,title="",msg,duration,showClose,icon,options={}){
	let op={
        type: type,//主题 success/warning/info/error	info
        duration: duration,
        showClose:showClose,//是否显示关闭按钮
        // offset:20,//Message 距离窗口顶部的偏移量
		// center: true,
		dangerouslyUseHTMLString: true,
		// iconClass:"null",
		message: '<div style="display: flex;align-items:center;">'+
					'<img src="'+icon+'" style="width:42.77px;height:42.77px;margin-right:17px;"></img>'+
					'<div style="font-size:16px;font-family:PingFang SC;font-weight:400;line-height:22px;">'+
						'<div style="color:#333;">'+title+'</div>'+
						'<div style="color:#666;margin-top:3px;">'+msg+'</div>'+
					'</div>'+
				'</div>',
	};
	for(var i in options){
		op[i]=options[i];
	}
	Message (op);
}

// /**
//  * [消息提示]
//  * @param msg  [内容]
//  */
// export function messageInfo(msg){
// 	message_base("info",msg,1.5*1000,false);
// }

/**
 * [消息提示]
 * @param msg  [内容]
 */
export function messageError(msg,title){
	// message_base("error",msg,1.5*1000,false);
	message_base2("error",title,msg,1.5*1000,false,require('@/assets/images/general/toast_error.png'));
}

/**
 * [消息提示]
 * @param msg  [内容]
 */
export function messageSuccess(msg,title){
	// message_base("success",msg,1.5*1000,false);
	message_base2("success",title,msg,1.5*1000,false,require('@/assets/images/general/toast_success.png'));
}


/**
 * [固定错误提示]
 * @param earr  [接口返回的对象信息]
 */
export function fixedError(earr,title){
	if(earr&&earr.message){
		messageError(earr.message,title);
	}else{
		messageError("服务器连接失败 或者 返回数据结构有误",title);
	}
}
//===================消息提示（吐司）===================



//===================消息提示确认框（alert）===================
/**
 *
 * @param {内容} message
 * @param {标题} title
 */
export function alert_confirm(message,title,options){
  let op = {
    showClose:false,
    center:true,
  };
  Object.assign(op, options)
	return MessageBox.confirm(message, title,op);
}

/**
 * 确认框(有取消)
 * @param {内容} message
 * @param {标题} title
 */
export function alert(message,title='提示',options){
	return alert_confirm(message,title,options);
}

/**
 * 确认框
 * @param {内容} message
 * @param {标题} title
 */
export function alertConfirm(message,title='提示',options){
	let op = {
		showCancelButton:false,
		closeOnClickModal:false,
	};
	Object.assign(op, options);
	return alert_confirm(message,title,op);
}

/**
 * [固定错误提示]
 * @param earr  [接口返回的对象信息]
 */
export function fixedAlertConfirm(earr,title,options){
	if(earr&&earr.message){
		alertConfirm(earr.message,title,options);
	}else{
		alertConfirm("请在“涪陵教育信息化工作群联系技术人员",title,options);
	}
}
//===================消息提示确认框（alert）===================



//===================加载进度框===================
/**
 * 加载进度框(单例)
 * @param {内容} text
 * @param {是否显示} isShow
 */
let loadingInstance=undefined;
export function progressLoad(text="加载中...",isShow,options) {
	let op = {
		lock: true,
		text: text,
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0,0.5)',
	};
	Object.assign(op, options);
	if(isShow){
		if(loadingInstance==undefined){
			loadingInstance = Loading.service(op);
		}
	}else{
		if(loadingInstance){
			loadingInstance.close();
			loadingInstance=undefined;
		}
	}
    // return loadingInstance;
}
//===================加载进度框===================
